<template>
    <div class="roothome_m">

        <div class="wrapper" style="background-color: white;">

            <!-- ################    Top Menu Bar Mobile   ################# -->
            <div align="center" class="head0">
                <div align="center" class="head0_2m">
                    <div class="head1m">
                        <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToHome()" onMouseOver="this.style.cursor='pointer'">
                    </div>
                    <div class="head2m">
                        <span class="tx_logol" style="font-size: var(--font-size-title-mobile_small);">{{ getInterText(inter_ind.tabua_mares) }} 2024</span>
                    </div>
                <div  class="head3m">

                    <div v-if="!user.sucess" class="di_profile" @click="setShowLogin(true)">
                        <img src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile_m2">
                    </div>

                    <div v-else class="di_profile" @click="showPopEscritorio()">
                        <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                            <span class="tx_initials" >{{ getInitials(user) }}</span>
                        </div>
                        <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_m2">
                        <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_m2">
                    </div>
                    <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                        <div class="arrow_top"></div>
                        <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click.prevent.stop="goToMinhaPagina()">{{ getInterText(inter_ind.minha_conta) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                    </div>
                </div>
                </div>
            </div>

            <!--Barra de cabecalho com imagem-->
            <img src="/static/imgs/bg_picao2.jpg" style="width: 100%; height: auto; object-fit: cover; margin-top: var(--top-bar-heigth); object-position: top;"/>

            <div style="display: flex; justify-content: flex-end; align-items: flex-end; flex-direction: row; margin-right: 2vw; margin-top: 2vw;">
                <div v-if="share" style="display: flex; margin-right: 2vw; justify-content: space-between; width: 17vw;">
                    <img @click="goShare(0)" src="/static/imgs/ic_share_whats_3d.png" style="height: 5vw; object-fit: contain;">
                    <img @click="goShare(1)" src="/static/imgs/ic_share_face_3d.png"  style="height: 5vw; object-fit: contain;">
                    <img @click="goShare(2)" src="/static/imgs/ic_share_link_3d.png"  style="height: 5vw; object-fit: contain;">
                </div>
                <img v-if="share" @click="showShare()" src="/static/imgs/ic_share_blue.png" alt="Share" style="height: 5vw; object-fit: contain; cursor: pointer;"/>
                <img v-else @click="showShare()" src="/static/imgs/ic_share.png" alt="Share" style="height: 5vw; object-fit: contain; cursor: pointer; "/>
            </div>

            <div class="div_expedicao">
                <div class="ct_arrow">
                    <img class="bt_arrow1" src="/static/imgs/ic_back_b.png" @click="changeTab(-1)"/>
                    <span class="tx_title_tabua">{{ getMes(tabuas[currTab].mes) }} {{ tabuas[currTab].ano }}</span>
                    <img class="bt_arrow2" src="/static/imgs/ic_back_b.png" @click="changeTab(1)"/>
                </div>
                <span style="margin-bottom: 3vh;"> João Pessoa / Porto de Cabedelo</span>
                <img class="im_tabua" :src="tb_img_base + tabuas[currTab].ano + '_' + tabuas[currTab].mes +'.jpg'" style="height: 100%; width: 80%; object-fit: contain;"/>
            </div>


            <div style="height: 3vh;"/>
        </div>


        <!--Janela Login-->
        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>

                <div v-if="!isiOS()" class="div_face_w" style="margin-top: 8vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">
                <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh">-->
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>
                <div v-else style="height: 12vh;"/>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                    <span class="tx_nome_w" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" class="input_name_w" type="text" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                    <span class="tx_nome_w" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_w" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1; text-align: left;">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>

                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>
                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'mRegisterUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" > {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'
    import Slider from '@/components/templates/Slider.vue'

    export default {
        mixins: [advMixin],
        name: 'mTabua',
        data () {
            return {
                name: 'mTabua',
                tb_img_base: '/static/tabua/tb_',
                currTab: 1,
                share: false,
                tabuas: [
                    {
                        ano: 2024,
                        mes: 1
                    },
                    {
                        ano: 2024,
                        mes: 2
                    },
                    {
                        ano: 2024,
                        mes: 3
                    },
                    {
                        ano: 2024,
                        mes: 4
                    },
                    {
                        ano: 2024,
                        mes: 5
                    },
                    {
                        ano: 2024,
                        mes: 6
                    },
                    {
                        ano: 2024,
                        mes: 7
                    },
                    {
                        ano: 2024,
                        mes: 8
                    },
                    {
                        ano: 2024,
                        mes: 9
                    },
                    {
                        ano: 2024,
                        mes: 10
                    },
                    {
                        ano: 2024,
                        mes: 11
                    },
                    {
                        ano: 2024,
                        mes: 12
                    }
                ]
            }
        },
        methods: {
            changeTab(i) {
                if (i > 0) {
                    if (this.currTab < this.tabuas.length - 1) {
                        this.currTab++;
                    }
                } else {
                    if (this.currTab > 0) {
                        this.currTab--;
                    }
                }
            },
            getMes(mes) {
                switch (mes) {
                    case 1: return 'JANEIRO';
                    case 2: return 'FEVEREIRO';
                    case 3: return 'MARÇO';
                    case 4: return 'ABRIL';
                    case 5: return 'MAIO';
                    case 6: return 'JUNHO';
                    case 7: return 'JULHO';
                    case 8: return 'AGOSTO';
                    case 9: return 'SETEMBRO';
                    case 10: return 'OUTUBRO';
                    case 11: return 'NOVEMBRO';
                    case 12: return 'DEZEMBRO';
                }
            }
        },
        created() {
            console.log(this.name + '::created!!');

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                }
            }

            let d = new Date()
            this.currTab = d.getMonth();

            console.log(this.name + '::Terminei o created!!');
        },
        beforeMount() {
            console.log(this.name + '::beforeMount!!');

            console.log(this.name + '::Terminei o beforeMount!!');
        },
        mounted() {
            console.log(this.name + '::mounted::!!');

            console.log(this.name + '::Terminei o mounted!!');
        },
    }
</script>


<style src="../assets/css/adv.css" scoped/>
<!--<style src="../assets/css/menu_icon.css" scoped/>-->
<!--<style src="../assets/css/advDesk.css" scoped/>-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tx_title_tabua {
        font-size: 7vw;
    }

    .div_expedicao {
        margin: 2vh;
        background-color: white;
        background-size: cover;
        color: var(--bg-blue);
        font-size: 2vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-right: 2.5vw;
        padding-left: 2.5vw;
        padding-top: 2.5vw;
        padding-bottom: 0px;
        margin-bottom: 0px;
        /*background-color: #002b51;*/
    }

    .im_tabua {
        background-image: url("/static/imgs/advicep_horizontal.png");
        background-repeat: repeat-y;
    }

    .ct_arrow {
        width: 88%;
        /*background-color: red;*/
        display: flex;
        justify-content: space-between;
    }

    .bt_arrow1, .bt_arrow2 {
        width: 11vw;
        object-fit: contain;
        padding-left: 3vw;
        padding-right: 3vw;
    }
    .bt_arrow2 {
        transform: rotate(180deg);
    }
    .bt_arrow1:hover, .bt_arrow2:hover {
        filter: brightness(0.5);
    }
    .bt_arrow1:active, .bt_arrow2:active {
        filter: brightness(1.3);
    }
</style>



// WEBPACK FOOTER //
// src/components/mTabua.vue